<template>
  <RouterView />
</template>

<script lang="ts" setup>
import {version} from '../package.json';

console.info(`Running version ${version} in ${import.meta.env.MODE}`)
</script>
